import { gql } from "@apollo/client";
import {
  CustomerNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { Customer as CustomerEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import CustomerModel from "../../data/model/Customer";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const customersQuery = gql`
${CustomerNoNestingFragment}
${PaginatedListMetaNoNestingFragment}
query GetCustomers(${listVariables}) {
    customers(${listOptions}) {
        items {
           ...CustomerNoNesting
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const customerDefinition = new EntityResourceDefinition<
  CustomerEntity,
  CustomerModel
>({
  entity: "customers",
  query: customersQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.firstName = fetchedEntity.firstName;
    newEntity.lastName = fetchedEntity.lastName;
    newEntity.gender = fetchedEntity.gender || null;
    newEntity.emailAddress = fetchedEntity.emailAddress || null;
    newEntity.mobileNumber = fetchedEntity.mobileNumber || null;
    newEntity.phoneNumber = fetchedEntity.phoneNumber || null;
    newEntity.loyaltyPoints = fetchedEntity.loyaltyPoints || 0;
    newEntity.isRetailerCusAccount =
      fetchedEntity.isRetailerCusAccount || false;
    newEntity.isTradeCustomer = fetchedEntity.isTradeCustomer || false;
    newEntity.retailerId = fetchedEntity.retailerId || null;
  },
  fetchEntities: async (options) => {
    return pageQuery(client, "customers", customersQuery, options);
  },
});
